import React, { useEffect } from 'react';
import './AiMasterclass.css';
import MasterclassNavbar from './components/MasterclassNavbar';
import MasterclassHero from './components/MasterclassHero';
import LovableHero from './components/LovableHero';
import IndustryTools from './components/IndustryTools';
import BuildRealThings from './components/BuildRealThings';
import WhyYouShouldJoin from './components/WhyYouShouldJoin';
import OnePrice from './components/OnePrice';
import SecureYourSpot from './components/SecureYourSpot';
import MasterclassCurriculum from './components/MasterclassCurriculum';
import CEOSection from './components/CEOSection';
import CertificatesSection from './components/CertificatesSection';
import FeaturesAndFeesSection from './components/FeaturesAndFeesSection';
import RulesFormFooterSection from './components/RulesFormFooterSection';
import { motion } from 'framer-motion';

const AnimateSection = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "0px" }}
    transition={{ duration: 1.0, ease: [0.25, 0.1, 0.25, 1.0] }}
  >
    {children}
  </motion.div>
);

const AiMasterclass = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    if (!document.getElementById('inter-font')) {
      const link = document.createElement('link');
      link.id = 'inter-font';
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
  }, []);

  return (
    <div className="mc-container">
      {/* <MasterclassNavbar /> */}

      {/* Blended older versions from code.html mapping */}
      <AnimateSection><MasterclassHero /></AnimateSection>
      <AnimateSection><MasterclassCurriculum /></AnimateSection>

      {/* Lovable Exact Recreations */}
      <AnimateSection><LovableHero /></AnimateSection>
      <AnimateSection><IndustryTools /></AnimateSection>

      <AnimateSection><CEOSection /></AnimateSection>

      {/* Continuing Lovable exact recreations */}
      <AnimateSection><BuildRealThings /></AnimateSection>
      <AnimateSection><WhyYouShouldJoin /></AnimateSection>

      {/* Older feature section & certificates */}
      {/* <FeaturesAndFeesSection /> */}
      <AnimateSection><CertificatesSection /></AnimateSection>

      {/* Recreated Pricing & Secure Form from Lovable */}
      <AnimateSection><OnePrice /></AnimateSection>
      {/* <SecureYourSpot /> */}

      {/* Old Rules and Footer */}
      <AnimateSection><RulesFormFooterSection /></AnimateSection>
    </div>
  );
};

export default AiMasterclass;
